import { jsx as m } from "react/jsx-runtime";
import { useMemo as v } from "react";
import { AnalysisIcon as y } from "@ifrc-go/icons";
import { _ as F } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import M from "../Message/index.js";
import D from "../../hooks/useTranslation.js";
import '../../index88.css';const _ = "common", h = { messageTitleFetching: "Fetching data...", messageTitleFilteredDataNotAvailable: "Data is not available for selected filter!", messageTitleDataNotAvailable: "Data is not available!", messageTitleDataFailedToFetch: "Failed to fetch data!" }, b = {
  namespace: _,
  strings: h
}, N = "_default-message_wu986_1", A = "_overlay_wu986_2", c = {
  defaultMessage: N,
  overlay: A
};
function q(g) {
  const {
    className: f,
    compact: u,
    pending: e,
    overlayPending: d,
    filtered: i,
    empty: a,
    errored: s,
    emptyMessage: l,
    filteredEmptyMessage: o,
    pendingMessage: r,
    errorMessage: n,
    withoutIcon: p
  } = g, t = D(b), T = v(
    () => e ? r ?? t.messageTitleFetching : s ? n ?? t.messageTitleDataFailedToFetch : i ? o ?? t.messageTitleFilteredDataNotAvailable : a ? l ?? t.messageTitleDataNotAvailable : null,
    [
      a,
      e,
      i,
      s,
      l,
      o,
      r,
      n,
      t
    ]
  );
  return !a && !e && !s ? null : /* @__PURE__ */ m(
    M,
    {
      className: F(
        c.defaultMessage,
        e && d && c.overlay,
        f
      ),
      icon: !p && /* @__PURE__ */ m(y, {}),
      compact: u,
      title: T,
      pending: e
    }
  );
}
export {
  q as default
};
